// eslint-disable-next-line import/no-default-export
export default {
    REDUCER_KEY: "TEMPLATE_DOCUMENT",
    ENTITY_NAME: "templateDocument",
    RESOURCE: "templateDocument",
};
